<template>
  <div>
    <app-header/>
    <router-view/>
    <app-footer/>

    <!-- Login Modal -->
    <login-modal @openAppModal="openModal" ref="loginModal"/>
    <!-- Logout Modal -->
    <sweet-modal ref="logoutModal" overlay-theme="dark" icon="success">
      {{ $t('message.logout.logout_success') }}
    </sweet-modal>
    <!-- Request Email Modal -->
    <request-email-modal ref="requestEmailModal" :loginData="loginData"/>
    <!-- Loader Modal for logging-in -->
    <loader-modal ref="loaderModal"/>
    <!-- Success Register Modal -->
    <sweet-modal ref="successRegisterModal" overlay-theme="dark" icon="success">
      {{ $t('message.login.confirm_email_to_activate_account') }}
    </sweet-modal>
    <!-- Success Booking Modal -->
    <success-booking-modal/>
    <!-- Phone Verification Modal -->
    <phone-verification-modal ref="phoneVerificationModal"/>
    <!-- Line Verification Modal -->
    <line-verification-modal ref="lineVerificationModal"/>
    <!-- Line Contact Modal -->
    <line-contact-modal ref="lineContactModal"/>
    <!-- Professional Service Modal -->
    <professional-service-modal ref="profServiceModal"/>
    <!-- Confirm PDPA Modal -->
    <confirm-personal-topic-modal ref="confirmPersonalTopicModal"/>

    <!-- Load Facebook SDK for JavaScript -->
    <div id="fb-root" :class="{'d-none': !globalState.displayFBChat}"></div>
    <!-- Your customer chat code -->
    <!--    <div class="fb-customerchat"
             attribution="setup_tool"
             page_id="117756035283722">
        </div>-->

    <section id="floating-icon-contacts" :class="isHiddenChatButton">
      <div class="fab-container"
           ref="fab-container-floating-button"
           @mousemove="onMouseMoveFloatingButton($event)"
           @mouseleave="onMouseLeaveFloatingButton($event)"
           @click="onClickFloatingButton($event)"
      >
        <div class="fab shadow">
          <div class="fab-content">
            <span class="material-icons">
              <!-- <transition name="mode-fade" mode="out-in">
                <div v-if="!isActiveInMobile">
                  <img src="/static/img/floatingButton/call_center_crop_head.png" width="80"
                       class="img-fluid rounded-circle" alt="" id="img-call-center-crop">
                </div>
                <div v-else class="circle-close-rotate">
                 <span class="icon-cross"></span>
                 <span class="visually-hidden">Close</span>
                </div>
              </transition> -->
              <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank">
                <img src="/static/img/floatingButton/line.png" data-platform="line" class="img-fluid rounded-circle" width="80">
              </a>
            </span>
          </div>
        </div>
        <!-- <div class="sub-button shadow">
          <a href="tel:02-113-1138" target="_blank">
            <span class="item-icons">
              <img src="/static/img/floatingButton/telephone-call.png" data-platform="telephone" class="img-fluid rounded-circle" width="80">
            </span>
          </a>
        </div>
        <div class="sub-button shadow">
          <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank">
            <span class="item-icons">
               <img src="/static/img/floatingButton/line.png" data-platform="line" class="img-fluid rounded-circle" width="80">
            </span>
          </a>
        </div>
        <div class="sub-button shadow">
          <a href="https://m.me/beneatco" target="_blank">
            <span class="item-icons">
              <img src="/static/img/floatingButton/messenger.png" data-platform="messenger" class="img-fluid rounded-circle" width="80">
            </span>
          </a>
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { SweetModal } from 'sweet-modal-vue'
import Footer from './components/Footer'
import Header from './components/Header'
import LoginModal from './components/login/LoginModal'
import LoaderModal from './components/loader/LoaderModal'
import RequestEmailModal from './components/login/RequestEmailModal'
import SuccessBookingModal from './components/booking/components/SuccessBookingModal.vue'
import LineContactModal from './components/modal/LineContactModal'
import LineVerificationModal from './components/modal/LineVerificationModal'
import PhoneVerificationModal from './components/modal/PhoneVerificationModal'
import ProfessionalServiceModal from './components/modal/ProfessionalServiceModal'
import ConfirmPersonalTopicModal from './components/privacy/ConfirmPersonalTopicModal'
import { firebaseAuth, firebaseMessaging, isSupportedMessaging } from './helpers/firebaseHelpers'
import { getToken, onMessage } from 'firebase/messaging'
import { FacebookAuthProvider, getRedirectResult, signOut } from 'firebase/auth'
import moment from 'moment-timezone'
import axios from 'axios'
import loginHelpers from './helpers/loginHelpers'
// import i18n from './helpers/i18nHelpers'

moment.tz.setDefault('Asia/Bangkok')

export default {
  name: 'AppComponent',
  components: {
    appHeader: Header,
    appFooter: Footer,
    SweetModal,
    LoginModal,
    RequestEmailModal,
    SuccessBookingModal,
    LineContactModal,
    LineVerificationModal,
    PhoneVerificationModal,
    ProfessionalServiceModal,
    ConfirmPersonalTopicModal,
    LoaderModal
  },
  data () {
    return {
      loginData: {
        social_id: null,
        firstname: null,
        lastname: null,
        email: null,
        picture: null,
        social_name: null,
        token: null
      },
      isFBReady: false,
      isActiveInMobile: false,
      noChatRoutes: ['/booking', '/booking/start', '/cleaner/:id', '/cleaners',
        '/special-services/:id', '/review', '/promotion', '/promotion-review',
        '/reservation/:id', '/professional-income/:id', '/professional-bonus/:id', '/professional-debt/:id',
        '/cleaner/:id/card', '/my-reservations', '/relax', '/recent-reviews', '/twitter-campaign', '/facebook-post',
        '/line/login', '/special-services/search', '/chat-booking', '/article/category', '/article/category/:name',
        '/line-provider/login', '/line-professional/login', '/line-professional/callback', '/invite-friends', '/finnix',
        '/professional/:id/examination', '/professional-questionnaire/:id/test', '/pre-qr-payments',
        '/term', '/covid19-terms', '/privacy', '/pdpa', '/job-posts', '/job-posts/:id', '/services/:id',
        '/partners/:id/report', '/professional-login', '/professional-dashboard', '/professional-register',
        '/q-chang', '/q-chang/1', '/q-chang/2', '/cleaner/:id/contracts/1', '/cleaner/consents/1', '/cleaner/:id/contracts/2',
        '/agency-professional-register', '/user/shipping-address', '/survey-ironing', '/survey-bathroom-cleaning', '/cleaner/:id/consents/1',
        '/cleaner/:id/consents/2', '/survey/1', '/recruitment', '/mikuagency', '/million-booking-celebrate', '/lineman-promotion', '/admin/:id/test/:testId', '/airbnb/login-callback'
      ],
      noPartnerPopupRoutes: ['/professional-login', '/job-posts', '/chat-booking', '/agency-professional-register', '/user/shipping-address', '/recruitment', '/mikuagency']
    }
  },
  metaInfo () {
    return {
      meta: [{
        vmid: 'description',
        name: 'description',
        content: 'BeNeat.co - ผู้ช่วยค้นหาแม่บ้านคุณภาพใกล้บ้านคุณ จองแม่บ้านออนไลน์ได้สะดวก รวดเร็ว พร้อมรับประกันคุณภาพ | Easy way to find your local cleaning expert'
      }]
    }
  },
  computed: {
    ...mapGetters({
      globalState: 'globalVal/getState',
      isLoggingOut: 'auth/isLoggingOut',
      registerSuccess: 'auth/getRegisterSuccess',
      state: 'auth/getState',
      user: 'auth/getUser',
      referralCode: 'auth/getReferralCode',
      isCheckingLogin: 'partner/getIsCheckingLogin'
    }),
    ...mapState('auth', ['isLineLoggedIn', 'registerFrom', 'professional', 'checkFavoriteTempData']),
    ...mapState('review', ['reviewedRating']),
    ...mapState('user', ['userVerification', 'skipAddingLine']),
    ...mapState('userPersonalTopic', ['displayConfirmation']),
    isHiddenChatButton () {
      return {
        'd-none': (this.noChatRoutes.indexOf(this.$route.matched[0].path) > -1 || this.isLineLoggedIn || ['AC Cleaning'].includes(this.$route.name))
      }
    }
  },
  watch: {
    isFBReady () {
      if (this.isFBReady) {
        this.checkFacebookChat(this.$router.currentRoute.matched[0].path)
      }
    },
    $route (to, from) {
      const routePath = to.matched[0].path
      this.checkFacebookChat(routePath)
    },
    isCheckingLogin () {
      if (!this.isCheckingLogin) {
        this.$refs.loaderModal.closeModal()
      }
    },
    // Watch for displaying modal when logout is completed
    isLoggingOut () {
      if (!this.state.isLoggingOut) {
        this.clearLocalStorage()
        if (this.$route.matched[0].path !== '/chat-booking' && this.$route.path !== '/') {
          this.$router.push('/')
          this.$refs.logoutModal.open()
        }
      }
    },
    registerSuccess () {
      if (this.state.registerSuccess) {
        this.$refs.loginModal.closeModal()
        this.$refs.successRegisterModal.open()
      }
    },
    async user () {
      if (this.user) {
        // Check User PDPA acceptance
        const params = {
          user_id: this.user.id,
          include_can_decline: true
        }
        await this.fetchUserPersonalTopics(params)
        if (window.localStorage.getItem('isLoggingIn') === 'true') {
          // Close all modals
          this.$refs.loginModal.closeModal()
          this.$refs.loaderModal.closeModal()
          this.$refs.requestEmailModal.closeModal()
          // Fetch global data
          await this.$store.dispatch('globalVal/LOAD_GLOBAL_DATA', { unlimited_package: 1, user_id: this.user.id })
          // Subscribe firebase cloud messaging
          this.subscribeFCM()
          // Check phone verification
          this.$store.dispatch('user/LOAD_USER_VERIFICATION', this.user.id)
          // Save user and token to local storage as well
          window.localStorage.setItem('isLoggingIn', 'false')
          window.localStorage.setItem('user', JSON.stringify(this.user))
          window.localStorage.setItem('token', this.state.token)
          // Add user fcm token after login for no login user
          const submitData = {
            user_id: this.user.id,
            token: this.state.fcmToken,
            platform: 'website'
          }
          this.$store.dispatch('auth/ADD_USER_TOKEN', submitData)

          // Fetch user places when route is new booking or cleaner detail
          if (this.$route.path === '/booking/start' || this.$route.matched[0].path === '/cleaner/:id') {
            let queryUserPlaceData = {
              user_id: this.user.id,
              province_id: ''
            }
            this.$store.dispatch('booking/LOAD_USER_PLACE_LIST', queryUserPlaceData)
          }

          // Check go to checkout step
          if (this.globalState.currentLoginPath === '/booking/choose-cleaner') {
            // Set booking from in order to back to previous page correctly
            const bookingFrom = {
              from: 'chooseCleaner',
              professionalId: null
            }
            this.$store.commit('booking/SET_BOOKING_FROM', bookingFrom)
            this.$router.push('/booking/checkout')
          } else if (this.globalState.currentLoginPath === '/cleaner/:id') {
            // Set booking from in order to back to previous page correctly
            const bookingFrom = {
              from: 'cleanerDetail',
              professionalId: this.$route.params.id
            }
            this.$store.commit('booking/SET_BOOKING_FROM', bookingFrom)
            this.$router.push('/booking/checkout')
            // Set user email data in preBookingData (vuex)
            this.$store.commit('booking/UPDATE_PRE_BOOKING_DATA', { key: 'email', value: this.user.email })
          }
        }
      }
    },
    userVerification () {
      // const noLinePopupPaths = ['/chat-booking', '/services/:id']
      // console.log('check noLinePopupPaths', this.$route.matched[0].path, noLinePopupPaths.indexOf(this.$route.matched[0].path) === -1)
      // noLinePopupPaths.indexOf(this.$route.matched[0].path) === -1
      if (this.userVerification) {
        // Check is review path
        const isReviewPath = (this.$route.matched[0].path === '/review')
        if (!isReviewPath) {
          if (!this.userVerification.is_phone_verified) {
            this.$refs.phoneVerificationModal.openModal()
          } else if (this.userVerification.is_phone_verified && !this.userVerification.is_line_verified && !this.skipAddingLine && this.$route.matched[0].path === '') {
            setTimeout(() => { this.$refs.lineVerificationModal.openModal() }, 3000)
          }
        }
      }
    },
    reviewedRating () {
      if (this.reviewedRating && this.reviewedRating <= 3) {
        this.$refs.lineContactModal.openModal()
      }
    },
    displayConfirmation () {
      if (this.displayConfirmation) {
        this.$refs.confirmPersonalTopicModal.openModal()
      }
    }
  },
  methods: {
    ...mapActions('user', ['fetchRemainingServiceHours']),
    ...mapActions('userPersonalTopic', ['fetchUserPersonalTopics']),
    onClickFloatingButton () {
      if (this.$mq.phone) {
        const elementButton = this.$refs['fab-container-floating-button']
        if (!elementButton.classList.contains('fab-container-button-hover')) {
          this.isActiveInMobile = true
          elementButton.classList.add('fab-container-button-hover')
        } else {
          this.isActiveInMobile = false
          elementButton.classList.remove('fab-container-button-hover')
        }
      }
    },
    onMouseLeaveFloatingButton (event) {
      const elementButton = this.$refs['fab-container-floating-button']
      if (elementButton.classList.contains('fab-container-button-hover')) {
        elementButton.classList.remove('fab-container-button-hover')
        this.isActiveInMobile = false
      }
    },
    onMouseMoveFloatingButton (event) {
      // only desktop will active mouse move
      if (!this.$mq.phone) {
        const elementButton = this.$refs['fab-container-floating-button']
        if (!elementButton.classList.contains('fab-container-button-hover')) {
          elementButton.classList.add('fab-container-button-hover')
        }
      }
    },
    setFirebaseCloudMessage () {
      try {
        if (isSupportedMessaging) {
          // Detect Message
          onMessage(firebaseMessaging, (payload) => {
            // console.log('payload1', payload)
            // console.log('payload2', payload.data.data)
            // Alert new message to user
            this.$store.commit('notification/SET_NEW_INBOX', true)
            const response = JSON.parse(payload.data.data)
            if (this.$route.matched[0].path === '/message' && Number(this.$route.query.pid) === Number(response.message.sender_id)) {
              const newMessage = {
                id: response.message.message_id,
                chat_room_id: response.message.chat_room_id,
                sender_id: response.message.sender_id,
                message: response.message.message,
                image_sm: response.message.image_sm,
                image_xl: response.message.image_xl,
                message_type_id: response.message.message_type_id,
                create_date: response.message.create_date,
                sender_type: response.message.sender_type,
                is_read: 1
              }
              this.$store.commit('message/ADD_NEW_MESSAGE_LIST', newMessage)
            } else if (this.$route.matched[0].path === '/inbox' && response.inbox) {
              this.$store.commit('inbox/ADD_NEW_INBOX', response.inbox)
            }
          })
        }
      } catch (e) {
        console.log('error setFirebaseCloudMessage', e)
      }
    },
    openProfessionalServiceModal (professional) {
      this.$refs.profServiceModal.setProfessional(professional)
    },
    checkFacebookChat (routePath) {
      // this.$store.commit('globalVal/SET_DISPLAY_FACEBOOK_CHAT', (this.noChatRoutes.indexOf(routePath) === -1))
      this.$store.commit('globalVal/SET_DISPLAY_FACEBOOK_CHAT', false) // force close
    },
    clearLocalStorage () {
      if (window.localStorage) {
        window.localStorage.clear()
      }
    },
    openModal (type) {
      if (type === 'login') {
        this.$store.commit('auth/SET_LOGIN_FORM_TYPE', 'login')
        this.$refs.loginModal.openModal()
      } else if (type === 'request-email') {
        this.$refs.requestEmailModal.openModal()
      } else if (type === 'booking') {
        this.$refs.bookingModal.openModal()
      }
    },
    closeModal () {
      this.$refs.loginModal.closeModal()
      this.$refs.bookingModal.closeModal()
    },
    async loginApp () {
      let submitData = { ...this.loginData, referral_code: this.referralCode }
      this.$store.dispatch('auth/LOGIN', submitData)
    },
    openLogoutDialog () {
      this.$swal({
        title: this.$i18n.t('message.confirm.title'),
        text: this.$i18n.t('message.confirm.confirm_logout'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#9E9E9E',
        reverseButtons: true,
        confirmButtonText: this.$i18n.t('message.button.confirm'),
        cancelButtonText: this.$i18n.t('message.button.cancel')
      }).then(() => {
        this.logoutApp()
      })
    },
    logoutApp () {
      signOut(firebaseAuth).then(() => {
        console.log('check firebase signout')
        const submitData = {
          user_id: this.user.id,
          token: null,
          platform: 'website'
        }
        this.$store.dispatch('auth/ADD_USER_TOKEN', submitData)
        this.$store.dispatch('auth/LOGOUT', this.user.id)
        // Logout clear booking data
        this.$store.commit('booking/SET_PRE_BOOKING_DATA', null)
        this.$store.commit('booking/SET_USER_PLACE_DATA', null)
        this.$store.commit('payment/SET_PAYMENT_DETAIL', null)
      }).catch((error) => {
        // An error happened.
        console.log(error)
      })
    },
    setLocaleLanguage (lang) {
      this.$store.commit('globalVal/SET_CURRENT_LANGUAGE', lang)
      this.$i18n.locale = lang
      moment.locale(lang)
    },
    checkLanguage () {
      if (this.$route.query.lang) {
        const lang = this.$route.query.lang
        this.$i18n.locale = lang
        moment.locale(lang)
      } else {
        this.setLocaleLanguage(this.globalState.currentLanguage)
      }
    },
    subscribeFCM () {
      try {
        console.log('check subscribeFCM')
        Notification.requestPermission().then((permission) => {
          if (permission === 'granted' && isSupportedMessaging) {
            getToken(firebaseMessaging, { vapidKey: 'BKSgt7HkIMmMSZc8MyePGwVuZtGdYqbErlbdMC4Tk4lxJQMCFcCHgP1Jug8BPfxEDVp2KffVjI9snv8qqcUr0eE' }).then((token) => {
              if (token) {
                // Keep token in database
                if (this.user) {
                  // console.log('Save Token')
                  const submitData = {
                    user_id: this.user.id,
                    token: token,
                    platform: 'website'
                  }
                  this.$store.dispatch('auth/ADD_USER_TOKEN', submitData)
                } else {
                  // Show permission request.
                  this.$store.commit('auth/SET_FCM_TOKEN', token)
                }
              } else {
                console.log('No Instance ID token available. Request permission to generate one.')
              }
            }).catch((error) => {
              console.log('An error occurred while retrieving token. ', error)
            })
          } else {
            console.log('Unable to get permission to notify.')
          }
        }).catch((err) => {
          console.warn('Unable to get permission to notify.', err)
        })
      } catch (e) {
        console.log('error subscribeFCM test', e.getMessage())
      }
    },
    updateProfile () {
      this.$store.dispatch('auth/LOAD_USER_PROFILE', this.user.id)
      this.$store.dispatch('user/LOAD_USER_VERIFICATION', this.user.id)
    },
    checkPartnerLogin () {
      this.$refs.loaderModal.openModal()
      this.clearLocalStorage()
      const token = this.$route.query.token
      const accessToken = this.$route.query.access_token
      const queryData = {
        token: token,
        access_token: accessToken
      }
      this.$store.dispatch('partner/LOAD_USER_PARTNER_DETAIL', queryData)
    },
    checkFirebaseAuthenRedirected () {
      // Authenticate user when firebase is redirected
      getRedirectResult(firebaseAuth).then(async (result) => {
        // console.log('check firebase authen redirect', result)
        if (result && result.user) {
          // The signed-in user info.
          const user = result.user
          // Set data before logging in
          this.loginData.email = user.email
          this.loginData.picture = 'https://beneat.co/images/ic_unknown.png'
          this.loginData.token = user.refreshToken
          this.loginData.social_id = user.uid
          let socialName = null
          switch (result.providerId) {
            case 'google.com': {
              socialName = 'googleplus'
              const displayNameArr = user.displayName.split(' ')
              this.loginData.firstname = displayNameArr[0]
              this.loginData.lastname = displayNameArr[1]
              this.loginData.picture = `${user.photoURL}?size=200`
              this.loginData.social_name = socialName
              // Login BeNeat App
              this.loginApp()
              // Close Loader Modal
              this.$refs.loaderModal.closeModal()
            }
              break
            case 'facebook.com': {
              socialName = 'facebook'
              // This gives you a Facebook Access Token. You can use it to access the Facebook API.
              const credential = FacebookAuthProvider.credentialFromResult(result)
              const accessToken = credential.accessToken
              const url = `https://graph.facebook.com/me?fields=first_name,last_name,email&access_token=${accessToken}`
              const { data } = await axios.get(url)
              if (data) {
                this.loginData.firstname = data.first_name
                this.loginData.lastname = data.last_name
                this.loginData.picture = `https://graph.facebook.com/${data.id}/picture?width=200&height=200`
                this.loginData.email = data.email
                this.loginData.social_id = data.id
                this.loginData.social_name = socialName
                if (!data.email) {
                  // Close Loader Modal
                  this.$refs.loaderModal.closeModal()
                  // Open Request Email Modal
                  this.openModal('request-email')
                } else {
                  // Login BeNeat App
                  this.loginApp()
                }
              }
            }
              break
            case 'apple.com': {
              socialName = 'apple'
              const displayNameArr = user.displayName.split(' ')
              this.loginData.firstname = displayNameArr[0]
              this.loginData.lastname = displayNameArr[1] || ''
              this.loginData.social_id = user.uid
              this.loginData.social_name = socialName

              // Login BeNeat App
              this.loginApp()
              // Close Loader Modal
              this.$refs.loaderModal.closeModal()
            }
              break
          }
        } else {
          this.$refs.loaderModal.closeModal()
        }
      }).catch((error) => {
        // alert(this.$i18n.t('message.alert.email_is_registered_with_other_credentials'))
        this.$swal({ text: error.message, type: 'error' })
        this.$refs.loaderModal.closeModal()
      })
    },
    onFBReady () {
      this.isFBReady = true
    }
  },
  async mounted () {
    window.addEventListener('fb-sdk-ready', this.onFBReady)
    this.checkLanguage()
    // Check user is logging-in
    if (!this.user && window.localStorage.getItem('isLoggingIn') === 'true') {
      this.$refs.loaderModal.openModal()
    }
    this.checkFirebaseAuthenRedirected()
    this.checkFacebookChat(this.$route.matched[0].path)
    // Set firebase cloud message
    this.setFirebaseCloudMessage()
    // Check phone verification
    if (this.user) {
      const { data } = await axios.get(`users/${this.user.id}`)
      if (!data.error) {
        const userData = loginHelpers.getUserData(data)
        this.$store.commit('auth/SET_USER_DATA', userData)
      }
    }
  },
  async created () {
    // Fetch global data
    let queryData = (this.user) ? { unlimited_package: 1, user_id: this.user.id } : { unlimited_package: 1 }
    await this.$store.dispatch('globalVal/LOAD_GLOBAL_DATA', queryData)
    if (this.user) {
      await this.fetchRemainingServiceHours(this.user.id)
    }
  }
}
</script>

<style lang='sass'>
@import '../node_modules/bootstrap/scss/bootstrap.scss'
@import './static/sass/beneat.sass'

.mode-fade-enter-active, .mode-fade-leave-active
  transition: opacity .5s ease

.mode-fade-enter-from, .mode-fade-leave-to
  opacity: 0

</style>



// WEBPACK FOOTER //
// src/App.vue